import { render, staticRenderFns } from "./UploadFreetextModal.vue?vue&type=template&id=8139cbee&"
import script from "./UploadFreetextModal.vue?vue&type=script&lang=js&"
export * from "./UploadFreetextModal.vue?vue&type=script&lang=js&"
import style0 from "./UploadFreetextModal.vue?vue&type=style&index=0&id=8139cbee&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports